import BankAccountFields from '@reverbdotcom/discovery-ui/dist/components/bank_account_fields';
import { CURRENCY_CODES, PAYOUT_METHODS } from '../../../shared/constants';
import * as classNames from 'classnames';
import * as PropTypes from 'prop-types';
import * as React from 'react';
import UrlHelpers from '../../../shared/url_helpers';
import ErrorMessage from '../../../shared/error_message';

export class PayoutMethodOptions extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isEditing: this.hasDirectCheckoutProfileErrors || !this.props.hideBankAccountEditForm,
      selectedPayoutMethod: this.payoutMethodInitiallySelected,
      selectedPayoutCurrency: this.props.profileAttributes.currency,
    };
  }

  onlyACHPayoutMethod() {
    return (
      <div className="mb-1">
        <input
          value={PAYOUT_METHODS.ACH}
          type="hidden"
          defaultChecked
          name={this.nameForField('payout_method')}
        />
        <p className="weight-bold mb-0">
          {I18n.t('js.dashboard.selling.shopPolicies.directCheckoutProfile.achPayoutDescription.setUpForAch')}
        </p>
        <p dangerouslySetInnerHTML={{ __html: this.achPayoutDescriptionText }} />
      </div>
    );
  }

  get payoutMethodInitiallySelected() {
    if (this.props.hideBankAccountEditForm) {
      return this.props.profileAttributes.payoutMethod;
    }

    return PAYOUT_METHODS.ACH;
  }

  nameForField(fieldName) {
    return `${this.props.formPrefix}[${fieldName}]`;
  }

  idForField(fieldName) {
    return `${this.props.formPrefix}-${fieldName}`;
  }

  achPayoutOption() {
    return (
      <li
        onClick={() => { this.setSelectedPayoutMethod(PAYOUT_METHODS.ACH); }}
      >
        <input
          className="boxed-list__toggle"
          type="radio"
          value={PAYOUT_METHODS.ACH}
          defaultChecked={this.isAch()}
          name={this.nameForField('payout_method')}
          id={this.idForField(PAYOUT_METHODS.ACH)}
        />
        <label
          className="boxed-list__item boxed-list__item--selectable"
          htmlFor={this.idForField(PAYOUT_METHODS.ACH)}
          data-slide-down-target=".pay-out-to-bank-tips"
          data-slide-up-target=".pay-out-to-bucks-tips"
        >
          <p className="weight-bold mb-0">{I18n.t('js.dashboard.selling.shopPolicies.directCheckoutProfile.payOutToBankAccount')}</p>
          <ul className={classNames('normal small pay-out-to-bank-tips', { hidden: this.isReverbBank() })}>
            <li dangerouslySetInnerHTML={{ __html: this.achPayoutDescriptionText }} />
          </ul>
        </label>
      </li>
    );
  }

  remindMeLaterOption() {
    if (this.state.selectedPayoutMethod === PAYOUT_METHODS.ACH && this.props.dcProfileComplete) {
      return null;
    }
    return (
      <li
        onClick={() => { this.setSelectedPayoutMethod(PAYOUT_METHODS.REVERB_BANK); }}
      >
        <input
          className="boxed-list__toggle"
          type="radio"
          value="reverb"
          defaultChecked={!this.isAch()}
          name={this.nameForField('payout_method')}
          id={this.idForField('reverb_bank')}
        />
        <label
          className="boxed-list__item boxed-list__item--selectable"
          htmlFor={this.idForField('reverb_bank')}
          data-slide-down-target=".pay-out-to-bucks-tips"
          data-slide-up-target=".pay-out-to-bank-tips"
        >
          <p className="weight-bold mb-0">{this.remindMeLaterTitle}</p>
          <ul className={classNames('normal small pay-out-to-bucks-tips', { hidden: this.isAch() })}>
            <li dangerouslySetInnerHTML={{ __html: this.remindMeLaterDescription }} />
            <li>
              <div className="label-with-checkbox">
                <input
                  type="checkbox"
                  value="1"
                  defaultChecked={this.props.profileAttributes.hasAcceptedReverbBankTerms}
                  name={this.nameForField('accepted_terms_at')}
                  id="reverb-bucks-conversion-terms-checkbox"
                />
                <label htmlFor="reverb-bucks-conversion-terms-checkbox">
                  <div dangerouslySetInnerHTML={{ __html: this.acceptReverbBankTerms }} />
                </label>
              </div>
            </li>
          </ul>
        </label>
      </li>
    );
  }

  reverbBankandACHPayoutMethodOptions() {
    return (
      <div className="form-group">
        <div className="form-group__header">
          <label>
            {I18n.t('js.dashboard.selling.shopPolicies.directCheckoutProfile.whereShouldYourEarningsGo')}
          </label>
        </div>
        <div className="form-group__fields">
          <ul className="payout-form">
            {this.achPayoutOption()}
            {this.remindMeLaterOption()}
          </ul>
        </div>
      </div>
    );
  }

  canPayoutToReverbBank() {
    return this.props.shopCurrency === CURRENCY_CODES.USD && this.props.shopLocatedInUs;
  }

  payoutMethodsSection() {
    if (this.canPayoutToReverbBank()) {
      return this.reverbBankandACHPayoutMethodOptions();
    }
    return this.onlyACHPayoutMethod();
  }

  get achPayoutDescriptionText() {
    if (this.props.preferredSeller) {
      return I18n.t('js.dashboard.selling.shopPolicies.directCheckoutProfile.achPayoutDescription.preferredSellerPayOutTimingMessage');
    }
    if (this.props.hasCompletedPayouts) {
      return I18n.t('js.dashboard.selling.shopPolicies.directCheckoutProfile.achPayoutDescription.payOutTimingMessageHtml', { linkOpen: `<a href='${UrlHelpers.reverbPaymentsFaqPath}' rel='noreferrer noopener' target='_blank'>`, linkClose: '</a>' });
    }
    return I18n.t('js.dashboard.selling.shopPolicies.directCheckoutProfile.achPayoutDescription.firstSalePayOutTimingMessageHtml', { linkOpen: `<a href='${UrlHelpers.reverbPaymentsFaqPath}' rel='noreferrer noopener' target='_blank'>`, linkClose: '</a>' });
  }

  get remindMeLaterTitle() {
    return I18n.t('js.dashboard.selling.shopPolicies.directCheckoutProfile.remindMeLater');
  }

  get remindMeLaterDescription() {
    return I18n.t('js.dashboard.selling.shopPolicies.directCheckoutProfile.remindMeLaterDescriptionHtml');
  }

  get acceptReverbBankTerms() {
    return I18n.t('js.dashboard.selling.shopPolicies.directCheckoutProfile.agreeToRemindMeLater');
  }

  updateSelectedPayoutCurrency(selectedPayoutCurrency) {
    this.setState({ selectedPayoutCurrency });
    this.props.onCurrencyChange(selectedPayoutCurrency);
  }

  bankAccountForm() {
    return (
      <div className={this.props.modularBankAccountFormClass}>
        {this.nevermindLink}
        <BankAccountFields
          fieldsNamePrefix={this.props.formPrefix}
          bankLookupUrl={this.props.bankLookupUrl}
          countryCode={this.props.profileAttributes.countryCode}
          countryCodeOptions={this.props.countryCodeOptions}
          onCountryChange={this.props.onCountryChange}
          currencies={this.props.payoutCurrencies}
          selectedPayoutCurrency={this.state.selectedPayoutCurrency}
          onCurrencyChange={(currency) => { this.updateSelectedPayoutCurrency(currency); }}
          shopCurrency={this.props.shopCurrency}
          dashboardView
        />
      </div>
    );
  }

  get bankName() {
    const name = this.props.profileAttributes.bankName;
    if (name) {
      return <p className="mb-0">{name}</p>;
    }
    return null;
  }

  bankSummary() {
    return (
      <div className="form-group mt-0 mb-2" data-readonly-profile-fields>
        <div className="form-group__header">
          <label>
            {I18n.t('js.dashboard.selling.shopPolicies.directCheckoutProfile.bankInfo')}
          </label>
          {this.securelyStoredDataParagraph}
        </div>
        <div className="form-group__fields">
          <p className="mb-0">{this.props.profileAttributes.nameOnAccount}</p>
          <p className="mb-0">{this.props.profileAttributes.maskedNameSummary}</p>
          {this.bankName}
          <p className="mt-half mb-1">{this.useADifferentAccountLink}</p>
        </div>
      </div>
    );
  }

  get securelyStoredDataParagraph() {
    const text = I18n.t('js.dashboard.selling.shopPolicies.directCheckoutProfile.storedSecurelyAndEncryptedHtml', { icon: this.lockIcon });
    return (
      <span
        className="form-group__help-text mtb-0 ml-half"
        dangerouslySetInnerHTML={{ __html: text }}
      />
    );
  }

  setSelectedPayoutMethod(selectedPayoutMethod) {
    this.setState({
      selectedPayoutMethod,
    });
  }

  toggleEditing() {
    this.setState({
      isEditing: !this.state.isEditing,
    });
  }

  get useADifferentAccountLink() {
    const text = I18n.t('js.dashboard.selling.shopPolicies.directCheckoutProfile.useADifferentAccountHtml', { icon: this.editIcon });
    return (
      <a
        data-change-link
        dangerouslySetInnerHTML={{ __html: text }}
        onClick={() => { this.toggleEditing(); }}
      />
    );
  }

  get nevermindLink() {
    if (!this.props.hideBankAccountEditForm || !this.props.dcProfileComplete) {
      return false;
    }

    return (
      <p className="mb-1">
        <a data-nevermind-link onClick={() => { this.toggleEditing(); }}>
          {I18n.t('js.dashboard.selling.shopPolicies.directCheckoutProfile.nevermind')}
        </a>
      </p>
    );
  }

  get editIcon() {
    return '<span class="fa fa-pencil"></span>';
  }

  get lockIcon() {
    return '<span class="fa fa-lock"></span>';
  }

  get hasDirectCheckoutProfileErrors() {
    return (this.props.profileAttributes.profileErrors.length > 0);
  }

  get joinedDirectCheckoutProfileErrors() {
    return (this.props.profileAttributes.profileErrors.join(' '));
  }

  isAch() {
    return this.state.selectedPayoutMethod === PAYOUT_METHODS.ACH;
  }

  isReverbBank() {
    return !this.isAch();
  }

  renderPaymentMethodErrors() {
    if (!this.hasDirectCheckoutProfileErrors) {
      return null;
    }

    return (
      <ErrorMessage
        alertStyle="alert-error alert-small"
        message={this.joinedDirectCheckoutProfileErrors}
      />
    );
  }

  get showCollapsedAchSummary() {
    return !this.state.isEditing && this.props.dcProfileComplete;
  }

  get reverbBankSelected() {
    return !this.isAch() && this.canPayoutToReverbBank();
  }

  renderAchProfile() {
    if (this.reverbBankSelected) {
      return null;
    }

    if (this.showCollapsedAchSummary) {
      return this.bankSummary();
    }
    return this.bankAccountForm();
  }

  render() {
    return (
      <div>
        {this.renderPaymentMethodErrors()}
        <div className={this.props.modularFormContainerClass}>
          {this.payoutMethodsSection()}
        </div>
        {this.renderAchProfile()}
      </div>
    );
  }
}

PayoutMethodOptions.propTypes = {
  profileAttributes: PropTypes.object.isRequired,
  payoutCurrencies: PropTypes.object.isRequired,
  hideBankAccountEditForm: PropTypes.bool.isRequired,
  shopLocatedInUs: PropTypes.bool.isRequired,
  dcProfileComplete: PropTypes.bool,
  bankLookupUrl: PropTypes.string.isRequired,
  preferredSeller: PropTypes.bool,
  hasCompletedPayouts: PropTypes.bool,
  countryCodeOptions: PropTypes.array.isRequired,
  formPrefix: PropTypes.string.isRequired,
  reverbBankCurrencies: PropTypes.array.isRequired,
  selected: PropTypes.bool,
  shopCurrency: PropTypes.string.isRequired,
  onCountryChange: PropTypes.func,
  onCurrencyChange: PropTypes.func,
  modularFormContainerClass: PropTypes.string,
  modularBankAccountFormClass: PropTypes.string,
  user: PropTypes.object,
};

PayoutMethodOptions.defaultProps = {
  onCountryChange: () => null,
  onCurrencyChange: () => null,
};

export default PayoutMethodOptions;



// WEBPACK FOOTER //
// ./javascripts/components/dashboard/selling/shop_policies/payout_method_options.jsx